var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('u-header',{attrs:{"title":_vm.$t('_.object_overview', { object: _vm.$t('_.staff') })}}),_vm._v(" "),_c('users-form',{attrs:{"user-id":_vm.$userData.userId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }